import {NgModule} from '@angular/core';
import {PlaceholderComponent} from '../shared/placeholder.component';
import {ChannelFormComponent} from './channel-form.component';
import {UIRouterModule} from '@uirouter/angular';
import {Ng2DynamicStateDeclaration, dynamicStateConfigFn} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'assignment.survey.edit.channel',
    abstract: true,
    future: true,
    component: PlaceholderComponent,
  },
  {
    name: 'assignment.execution.edit.channel',
    abstract: true,
    future: true,
    component: PlaceholderComponent,
  },
  {
    name: 'assignment.maintenance.edit.channel',
    abstract: true,
    future: true,
    component: PlaceholderComponent,
  },
  {
    name: 'assignment.survey.edit.channel.add',
    future: true,
    component: ChannelFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.channel.add.pageTitle',
      scopes: ['channel:create']
    }
  },
  {
    name: 'assignment.survey.edit.channel.edit',
    future: true,
    component: ChannelFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.channel.edit.pageTitle',
      scopes: ['channel:update']
    }
  },
  {
    name: 'assignment.execution.edit.channel.add',
    future: true,
    component: ChannelFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.channel.add.pageTitle',
      scopes: ['channel:create']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit',
    future: true,
    component: ChannelFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.channel.edit.pageTitle',
      scopes: ['channel:update']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.add',
    future: true,
    component: ChannelFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.channel.add.pageTitle',
      scopes: ['channel:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit',
    future: true,
    component: ChannelFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.channel.edit.pageTitle',
      scopes: ['channel:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    })
  ]
})
export class ChannelRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel.routes.ts